<template>
  <v-dialog
    v-model="showModal"
    max-width="700"
    persistent
  >
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <validation-observer 
        v-slot="{ handleSubmit }"
        ref="validator"
      >
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">
            Thêm mới phòng ban
          </template>
          <template v-else>
            Cập nhật thông tin phòng ban
          </template>

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required|max:255"
                name="Tên phòng ban"
              >
                <v-text-field
                  v-model="department.name"
                  label="Tên phòng ban *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Loại phòng ban"
              >
                <v-autocomplete
                  :items="departmentType"
                  item-text="label"
                  item-value="value"
                  v-model="department.type"
                  label="Loại phòng ban *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Nhóm ngành"
              >
                <v-autocomplete
                  :items="schoolLevels"
                  item-text="name"
                  item-value="id"
                  v-model="department.schoolLevels"
                  label="Nhóm ngành *"
                  :error-messages="errors"
                  color="primary"
                  multiple
                  eager
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                name="Mô tả"
                rules="max: 255"
              >
                <v-textarea
                  v-model="department.description"
                  label="Mô tả"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(saveDepartment)"
          >
            Lưu lại
          </v-btn>
          <v-spacer />

          <v-btn
            color="primary"
            @click="hideModal"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const DepartmentRepository = RepositoryFactory.get('department')
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      schoolLevels: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        showModal: false,
        department: {
          name: '',
          description: '',
          type: '',
          schoolLevels: []
        },
        isCreate: true,
        departments: [],
        errorMessage: '',
        departmentType: [
          {
            label: 'Bán lẻ',
            value: 'retail'
          }, 
          {
            label: 'Đại lý',
            value: 'agency'
          }, 
          {
            label: 'CSKH',
            value: 'customer_care'
          }, 
          {
            label: 'Vận đơn',
            value: 'order_care'
          },
          {
            label: 'Marketing',
            value: 'mkt'
          },
          {
            label: 'CTV',
            value: 'ctv'
          }
        ]
      }
    },
    created () {
      Bus.$on('department-show-form', (department) => {
        this.showModal = true
        this.department = _.cloneDeep(department)
        if (department.id) this.isCreate = false
        if (department.schoolLevel) {
          this.department.schoolLevels = department.schoolLevel.map(item => item.id)
        }
        else this.isCreate = true
      })
    },
    methods: {
      hideModal: function () {
        this.showModal = false
        this.isCreate = true
        this.errorMessage = ''
        this.$refs.validator.reset()
      },
      async saveDepartment () {
        if (this.isCreate) {
          const department = {
            name: _.trim(this.department.name),
            description: _.trim(this.department.description),
            type: this.department.type,
            schoolLevels: this.department.schoolLevels
          }
          const loader = this.$loading.show()
          const response = await DepartmentRepository.create(department)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.showModal = false
            this.errorMessage = ''
            this.$swal({
                      title: 'Thêm phòng ban thành công',
                      confirmButtonText: 'Đồng ý',
                    },
            ).then(() => {
              Bus.$emit('department-list-reload')
            })
          }
          loader.hide()
        } else {
          const department = {
            name: _.trim(this.department.name),
            description: _.trim(this.department.description),
            type: this.department.type,
            schoolLevels: this.department.schoolLevels
          }
          const loader = this.$loading.show()
          const response = await DepartmentRepository.update(this.department.id, department)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.showModal = false
            this.errorMessage = ''
            this.$swal({
                      title: 'Cập nhật phòng ban thành công',
                      confirmButtonText: 'Đồng ý',
                    },
            ).then(() => {
              Bus.$emit('department-list-reload')
            })
          }
          loader.hide()
        }
      },
    },
  }
</script>
